export const BILLING_SUBSCRIPTION_SETTINGS_PATH = "/settings?tab=subscription";

export const getLatestBillingSubscription = (payload) => {
  const billingSubscriptions = payload?.billingSubscriptions;
  const billingSubscriptionsList = Array.isArray(billingSubscriptions)
    ? billingSubscriptions
    : billingSubscriptions
      ? [billingSubscriptions]
      : [];

  return billingSubscriptionsList.length > 0
    ? billingSubscriptionsList[billingSubscriptionsList.length - 1]
    : null;
};

export const getBillingSubscriptionStatus = (payload) => {
  const latestBillingSubscription = getLatestBillingSubscription(payload);
  return latestBillingSubscription?.status ?? null;
};

export const isPastDueBillingStatus = (status) =>
  String(status || "").trim().toUpperCase() === "PAST_DUE";

export const isBillingPastDue = ({ tokenData, summary } = {}) => {
  const summaryStatus = summary?.subscription?.status ?? null;
  return (
    tokenData?.billingReason === "SUBSCRIPTION_PAST_DUE" ||
    isPastDueBillingStatus(summaryStatus) ||
    isPastDueBillingStatus(getBillingSubscriptionStatus(tokenData))
  );
};

export const resolveBillingBlockedRoute = ({
  canAccessUpgrade,
  settingsRoute = "/settings",
  upgradeRoute = "/upgrade",
  tokenData,
  summary,
} = {}) => {
  if (isBillingPastDue({ tokenData, summary })) {
    return BILLING_SUBSCRIPTION_SETTINGS_PATH;
  }

  return canAccessUpgrade ? upgradeRoute : settingsRoute;
};
